import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import moment from '../../utils/helpers/moment'
import PropTypes from 'prop-types'
import ValidationDatePicker from "../ValidationDatePicker";
 
class EcheanceDevis extends Component {
  static propTypes = {
    getStartDate: PropTypes.object,
    checkChangeStartDate: PropTypes.func.isRequired,
  }
  constructor (props) {
    super(props)
    let getStartDate = props.getStartDate ? moment(props.getStartDate) : moment().add(1, 'd')
    this.state = { startDateSouscription: getStartDate, endDateSouscription: this.getEndDate(getStartDate), form: [] }
    this.handleChangeDatePickerStartDateSouscription = this.handleChangeDatePickerStartDateSouscription.bind(this)
    props.checkChangeStartDate(moment(getStartDate, "DD-MMM-YYYY").valueOf())
  }
  getEndDate = (date) => {
    return date ? moment(date).add(1, 'y').subtract(1, 'd') : null
  }
  handleChangeDatePickerStartDateSouscription(newStartDate, errorPayload){
    this.setState({ startDateSouscription: newStartDate, endDateSouscription: this.getEndDate(newStartDate) })
    let date = newStartDate ? moment(newStartDate, "DD-MMM-YYYY").valueOf() : null
    const { checkChangeStartDate } = this.props
    checkChangeStartDate(date)

    let err = errorPayload;
    this.setState((prev, props) => {
      prev.form[err.name] = !err.hasError;
      this.props.checkFormValid(
        "echeance-devis",
        Object.values(prev.form).reduce((a, b) => a && b)
      );
      return { form: prev.form };
    });
  }
  handleOnError = (event, errorPayload) => {
    let err = errorPayload;
    this.setState((prev, props) => {
      prev.form[err.name] = !err.hasError;
      this.props.checkFormValid(
        "echeance-devis",
        Object.values(prev.form).reduce((a, b) => a && b)
      );
      return { form: prev.form };
    });
  };

  render() {
    const { startDateSouscription, endDateSouscription } = this.state

    return(
      <div>
        <div className="aps-dashboard-devis-date-content aps-dashboard-devis-date-content-show-web aps-dashboard-date-grid" data-uk-grid>
          <div className="uk-width-1-2 aps-dashboard-date-grid-first-col">
            <div className="aps-dashboard-date-grid">
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-first-b1-content">
                <div className="aps-dashboard-date-title">
                  Date d&apos;effet souhaité :
                </div>
              </div>
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-second-b1-content">
                <div className="uk-inline aps-dashboard-date-field-container aps-section-register-fields-full-date-picker">
                  <span className="uk-form-icon uk-form-icon-flip aps-dashboard-date-field-icon" data-uk-icon="icon: calendar" />
                  <ValidationDatePicker
                    dateFormat="DD-MMM-YYYY"
                    placeholderText="Cliquez pour choisir"
                    locale="fr"
                    name="startDate"
                    minDate={moment().add(1, 'd')}
                    maxDate={moment().add(90, 'd')}
                    showYearDropdown
                    scrollableYearDropdown
                    selected={startDateSouscription}
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, date) =>
                      this.handleChangeDatePickerStartDateSouscription(date, errorPayload)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="uk-width-1-2 aps-dashboard-date-grid-second-col">
            <div className="aps-dashboard-date-grid">
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-first-b2-content">
                <div className="aps-dashboard-date-title">
                  Date d&apos;expiration :
                </div>
              </div>
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-second-b2-content">
                <div className="uk-inline aps-dashboard-date-field-container-two aps-section-register-fields-full-date-picker">
                  <span className="uk-form-icon uk-form-icon-flip aps-dashboard-date-field-icon" data-uk-icon="icon: calendar" />
                  <DatePicker
                    className="uk-input aps-dashboard-date-field"
                    dateFormat="DD-MMM-YYYY"
                    placeholderText="Votre date d'expiration"
                    locale="fr"
                    disabled
                    selected={endDateSouscription}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{display: "none"}} className="aps-dashboard-devis-date-content aps-dashboard-devis-date-content-show-mobile aps-dashboard-date-grid" data-uk-grid>
          <div className="uk-width-1-2 aps-dashboard-date-grid-first-col">
            <div>
              <hr className="aps-btn-mobile-pre-header-divider"/>
            </div>
            <div className="aps-dashboard-date-grid" style={{paddingTop: "17px"}} data-uk-grid>
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-first-b1-content uk-width-1-2">
                <div className="aps-dashboard-devis-desc uk-text-bold " style={{paddingTop: "8%"}}>
                  Date d&apos;effet :
                </div>
              </div>
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-second-b1-content uk-width-1-2">
                <div className="uk-inline aps-dashboard-date-field-container aps-section-register-fields-full-date-picker">
                  <span className="uk-form-icon uk-form-icon-flip aps-dashboard-date-field-icon" data-uk-icon="icon: calendar" />
                  <ValidationDatePicker
                    dateFormat="DD-MMM-YYYY"
                    placeholderText="Cliquez pour choisir"
                    locale="fr"
                    name="startDate"
                    showYearDropdown
                    scrollableYearDropdown
                    maxDate={moment().add(90, 'd')}
                    selected={startDateSouscription}
                    onBlur={(errorPayload, event) =>
                      this.handleOnError(event, errorPayload)
                    }
                    onChange={(errorPayload, date) =>
                      this.handleChangeDatePickerStartDateSouscription(date, errorPayload)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="uk-width-1-2 aps-dashboard-date-grid-second-col">
            <div className="aps-dashboard-date-grid" data-uk-grid>
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-first-b2-content uk-width-1-2">
                <div className="aps-dashboard-devis-desc uk-text-bold " style={{paddingTop: "8%"}}>
                  Date d&apos;expiration :
                </div>
              </div>
              <div className="aps-dashboard-date-grid-first-col aps-dashboard-date-second-b2-content uk-width-1-2">
                <div className="uk-inline aps-dashboard-date-field-container-two aps-section-register-fields-full-date-picker">
                  <span className="uk-form-icon uk-form-icon-flip aps-dashboard-date-field-icon" data-uk-icon="icon: calendar" />
                  <DatePicker
                    className="uk-input aps-section-register-fields"
                    dateFormat="DD-MMM-YYYY"
                    placeholderText="Votre date d'expiration"
                    locale="fr"
                    disabled
                    selected={endDateSouscription}
                  />
                </div>
              </div>
            </div>
            <div>
              <hr className="aps-btn-mobile-pre-header-divider"/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EcheanceDevis



// WEBPACK FOOTER //
// ./src/components/EcheanceDevis/index.js